import React from 'react';
import {
    BaseTabs,
    SimpleTable,
    AlertDialogue,
    GridContainer,
    GridItem,
    MasterLayoutMiddle,
    AlertAction,
    FooterInner
} from '@dclab/dc-react-ui-kit';

function JumahSalah(props) {

    const style = {
        width: '100%',
    };



    // ============================== Table Start ======================================//
    let col = [

        { type: 'link', name: 'invoice_number', label: 'JUMU AH DATE', width: '20%' },
        { type: 'string', name: 'name', label: 'KHUTBAH TIME', width: '20%' },
        { type: 'string', name: 'name', label: 'KHATEEB', width: '20%' },
        { type: 'string', name: 'date', label: 'INVITATION METHOD', width: '20%' },
        { type: 'string', name: 'date', label: 'STATUS', width: '20%' },
        { type: 'action', label: 'ACTION' }

    ];

    const selected_categories = col.sort((a, b) => a.order - b.order)
    let rows = selected_categories.map((text, index) => {
        let i = index + 1
        return (
            [
                { type: 'string', name: 'name', value: 'Aug 6, 2021' },
                { type: 'string', name: 'category', value: '1:45 PM' },
                { type: 'string', name: 'name', value: 'Dr. Omar Suleiman' },
                { type: 'string', name: 'category', value: '+1 (123) 123-1234, omarsuleiman@gmail.com' },

                { type: 'status', name: 'featured', value: 'active' },
                { type: 'action', status: 'success', value: 'see details' },

            ]
        )
    })


    // ============================== Table End ======================================//

    return (

        <MasterLayoutMiddle
            header={
                <>

                </>
            }
            content={
                <div className="table_box">
                    <SimpleTable
                        showHeader={true}
                        title="Salat-al-Jumu'ah"
                        width="100%"
                        rows={rows}
                        columns={col}
                        colSpan={16}
                        actionSendButton={true}
                        donationsCount={rows && rows.length > 0 ? 1 : 0}
                        noTitle="No inquiry submitted yet"
                        noPara="Inquiries submitted by visitors will be visible and managed here."
                        noBtnText=""
                        onInviteClick={() =>
                            props.history.push(
                                "/membership-details"
                            )
                        }
                        actionLink={(name) => props.history.push({ pathname: "/membership-details", state: { contact: name[0].data } })}
                        showIconCol={false}
                        deleteAction={(e) => console.log(e)}
                        showFooter={true}
                        showFilter={false}
                        filterText='Filter'
                        addText="ADD NEW"
                        showAdd={true}
                        rowsPerPage={5}
                        onAddClick={() => props.history.push("/add-new-jumah")}
                        iconTextSize={16}
                        sortColumnIndex={[4]}
                    />
                </div>
            }
            isFooter={true}
            footer={
                <FooterInner
                    style={style}
                    termsLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies" : "http://deenconnect.io/terms-policies"}
                    privacyLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies#privacy-policy" : "http://deenconnect.io/terms-policies#privacy-policy"}
                />
            }
            isWhiteBackground={false}
        />

    );
}


export default JumahSalah;